import { render, staticRenderFns } from "./HelpForm.vue?vue&type=template&id=43c29f72&"
import script from "./HelpForm.vue?vue&type=script&lang=js&"
export * from "./HelpForm.vue?vue&type=script&lang=js&"
import style0 from "./HelpForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports